module.exports = __webpack_public_path__ + "assets/measure_utilization.fa9f8788.svg";